import { render } from "./PasswordReset.vue?vue&type=template&id=552e63fb"
const script = {}

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/password/PasswordReset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "552e63fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('552e63fb', __exports__)) {
    console.log('reload')
    api.reload('552e63fb', __exports__)
  }
  
  module.hot.accept("./PasswordReset.vue?vue&type=template&id=552e63fb", () => {
    console.log('re-render')
    api.rerender('552e63fb', render)
  })

}


export default __exports__